const PAYMENT_STATUS = {
	succeeded: "succeeded",
	failed: "failed",
	pending: "pending"
};

export { PAYMENT_STATUS };
